module.exports = __webpack_public_path__ + "img/data-management.2b77495b.svg";